import { render, staticRenderFns } from "./applyStaffLeaveModal.vue?vue&type=template&id=797875a4&scoped=true"
import script from "./applyStaffLeaveModal.vue?vue&type=script&lang=js"
export * from "./applyStaffLeaveModal.vue?vue&type=script&lang=js"
import style0 from "./applyStaffLeaveModal.vue?vue&type=style&index=0&id=797875a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797875a4",
  null
  
)

export default component.exports